<template>
    <div class="uik-btn-group__wrapper">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "UikButtonGroup"
}
</script>

<style lang="scss">
.uik-btn-group__wrapper {
  display: inline-block;
  &>* {
    border-radius: 0;
    &:first-child {
      border-radius: 4px 0 0 4px;
    }
    &:last-child {
      border-radius: 0 4px 4px 0;
    }
    &:not(:last-child) {
      border-right-color: transparent;
    }
  }
}
</style>
